import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jqejnb29sd: FaireBrandEntity = {
  token: "b_jqejnb29sd",
  type: "brand",
  name: "Lady & Larder",
  avatarUrl:
    "https://cdn.faire.com/fastly/821571d81550f691b164b1b132a08cb5c28e7dd7e8ba03bfd032305aab327032.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f11357cb4c41b0dd212d05bca59d8f0da2a23cd217784f4fe2bb13207b66c14f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/821571d81550f691b164b1b132a08cb5c28e7dd7e8ba03bfd032305aab327032.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f11357cb4c41b0dd212d05bca59d8f0da2a23cd217784f4fe2bb13207b66c14f.png",
  location: "Santa Monica , CA, USA",
  minimumOrderDollars: 100,
  rating: 4.1,
  reviewCount: 10,
  isInsider: true,
  description:
    "The week before New Years Eve. We had a couple beers and shared our goals for the upcoming year. By the time we left, we had doodled a big dream on a small napkin. And not long after that, we committed all of our waking hours to making that dream come true. A whole lot of heart following and soul spilling, an idea utterly soaked in love and here we are, Lady & Larder. We are 100% family-owned and operated. We are sisters. We are best friends. And we grew up in the kitchen.\n\nWe are a part of the hospitality community. It's all we've ever known. It's in our blood. Over the years we've worked in restaurants, helped open restaurants, consulted with culinary teams, trained teams, worked with small joints and big corporations - you name it. Through La Femme Epicure, we've had the honor of working for some incredible clients. We have cooked all over the West Coast - in private homes and planes, in the middle of vineyards, in backyards, in big warehouses, under tents, up in the mountains and down by the sea. And what these experiences have given us, is a profound respect and sense of gratitude for the process of growing, preparing and cooking food for people we love. We grew up with the notion and still maintain that the dinner table is a sacred place and the only thing bigger than our love of food is our love of sharing it with others. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:46.482Z",
    importedBy: "entity-db-cli",
  },
};
